import { render, staticRenderFns } from "./TaskDeleteIndividual.vue?vue&type=template&id=b93532d0"
import script from "./TaskDeleteIndividual.vue?vue&type=script&lang=ts"
export * from "./TaskDeleteIndividual.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports